import React from 'react';
import { connect } from 'react-redux';
import { ErrorModal } from '../components/modals/error-modal';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'unmarkLabelPrinted.title',
    defaultMessage: 'Warning',
    id: 'KyFWRd',
  },
  messageStart: {
    description: 'unmarkLabelPrinted.messageStart',
    defaultMessage: 'This will remove the status',
    id: 'gS/KE7',
  },
  messageEnd: {
    description: 'unmarkLabelPrinted.messageEnd',
    defaultMessage: 'from the shipment. Are you sure?',
    id: 'RmO7Vx',
  },
  packingSlip: {
    description: 'unmarkLabelPrinted.packingSlip',
    defaultMessage: 'Packing Slip Printed',
    id: 'wJko1e',
  },
  label: {
    description: 'unmarkLabelPrinted.Label',
    defaultMessage: 'Label Printed',
    id: 'lkktKh',
  },
  cancel: {
    description: 'unmarkLabelPrinted.cancel',
    defaultMessage: 'Cancel',
    id: '+Hav+9',
  },
  yes: {
    description: 'unmarkLabelPrinted.yes',
    defaultMessage: 'Yes, Continue',
    id: 'BmQ0Yj',
  },
});

const warningMessage = (docType) => {
  const messageByDocType = docType === 'packing-slip' ? messages.packingSlip : messages.label;
  return (
    <span>
      <FormattedMessage {...messages.messageStart} />{' '}
      <b>
        <FormattedMessage {...messageByDocType} />
      </b>{' '}
      <FormattedMessage {...messages.messageEnd} />
    </span>
  );
};

const mapStateToProps = (state, props) => {
  const { modalFrameworkMethods, docType } = props;
  return {
    modalFrameworkMethods,
    state: 'warning',
    title: <FormattedMessage {...messages.title} />,
    message: warningMessage(docType),
  };
};

// dangerouslySetInnerHTML={{ __html: I18nService.formatMessage(translation) }}

const mapDispatchToProps = (dispatch, props) => {
  const { action } = props;
  return {
    buttons: [
      {
        children: <FormattedMessage {...messages.cancel} />,
      },
      {
        theme: 'primary',
        children: <FormattedMessage {...messages.yes} />,
        onClick: () => {
          dispatch({ ...action, override: true });
        },
      },
    ],
  };
};

export const UnmarkDocumentAsPrintedWarningContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
